function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 192,
  height: 188.041,
  rx: 48,
  fill: "url(#paint0_linear_20033820_93838)"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M96 114.074C57.84 114.074 42 150.684 42 150.684V37C42 37 57.84 73.6102 96 73.6102C134.16 73.6102 150 37 150 37V150.684C150 150.684 134.16 114.074 96 114.074Z",
  fill: "white"
});
var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_20033820_93838",
  x1: 4.43497e-7,
  y1: 94.0206,
  x2: 191.998,
  y2: 93.3588,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F97316"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0B54FF"
})));
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 189,
    viewBox: "0 0 192 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e4df5d85d5a96f4357bd4a59ac5ef4f3.svg";
export { ForwardRef as ReactComponent };